<template>
  <div>
    <v-dialog v-model="dialog" max-width="85vw">
      <v-img
          :src=         "clickedImage"
          :contain=     "true"
          @click.stop=  "dialog=false"/>
    </v-dialog>
    <Table :properties="tableProperties">
      <template v-slot:searchFields>
        <v-col cols="12" class="pb-0">
          <v-text-field
            hide-details
            clearable
            outlined
            reverse
            dense
            :label=           "$t('field.FREE_SEARCH')"
            :rules=           "searchRules"
            v-model=          "searchQuery"
            :loading=         "tableProperties.loading"
            @keypress.enter=  "applyLocalSearch"
          />
        </v-col>
      </template>
      <template v-slot:imageUrl="{ item }">
        <v-img contain :src="item.imageUrl" width="5rem" @click="zoom(item.imageUrl)"></v-img>
      </template>
      <template v-slot:RDP_STOCKFLAG="{ item }">
        <v-chip label v-if="item.RDP_STOCKFLAG" color="green" text-color="white">
          {{$t('field.InStock')}}
        </v-chip>
      </template>
      <template v-slot:YHV_SUBSTFLAG="{ item }">
        <v-chip label v-if="item.YHV_SUBSTFLAG" color="green" text-color="white">
          {{$t('field.HasReplacement')}}
        </v-chip>
      </template>
    </Table>
  </div>
</template>
<script>
  import { API }  from 'aws-amplify'
  import Table    from '../components/Table'

  const PAGE_SIZE = 100
  const LOAD_PAGE_SIZE = 500

  export default {
    name:       'Parts',
    components: { Table },
    data() {
      return {
        dialog:          false,
        clickedImage:    null,
        searchQuery:     '',
        partsLoadId:     0,
        searchRules:     [ v => this.searchRuleOk(v) ],
        tableProperties: {
          items:                    [],
          loading:                  false,
          itemsPerPage:             PAGE_SIZE,
          hideFreeSearch:           true,
          resetPageKey:             0,
          headers: [
            { text: this.$t('field.PARTNAME'),  value: 'PARTNAME',          width: '25%', align: 'start'  },
            { text: this.$t('field.PARTDES'),   value: 'PARTDES'                                          },
            { text: this.$t('field.PRICE'),     value: 'PRICE',             width: '10%'                  },
            { text: '',                         value: 'RDP_STOCKFLAG',     width: '1%'                   },
            { text: '',                         value: 'YHV_SUBSTFLAG',     width: '1%'                   },
            { text: 0,                          value: 'BLIZ_STOCKQUANT',                                 },
            { text: '',                         value: 'imageUrl',          width: '100px'                },
          ],
          dynamicFieldsSlots: [ 'imageUrl', 'RDP_STOCKFLAG', 'YHV_SUBSTFLAG', 'BLIZ_STOCKQUANT' ]
        }
      }
    },
    created() {
      this.applyLocalSearch()
    },
    mounted() {
      this.loadParts()
    },
    beforeDestroy() {
      this.partsLoadId += 1
    },
    methods: {
      zoom(url) {
        this.dialog       = true
        this.clickedImage = url
      },
      searchRuleOk(value) {
        const s = (value ?? this.searchQuery ?? '').toString().trim()
        if (s.length === 1) return this.$t('field.PartsSearchOneChar')
        return true
      },
      async loadParts() {
        if (this.$store.state.partsLoaded) {
          this.applyLocalSearch()
          return
        }

        const loadId = ++this.partsLoadId
        this.$store.commit('setParts', [])
        this.$store.commit('setPartsLoaded', false)
        this.applyLocalSearch()
        this.tableProperties.loading = true

        try {
          for (let page = 1; ; page++) {
            const res = await API.get('priority', '/apiv1/parts', {
              queryStringParameters: {
                progressive: 'true',
                page:        String(page),
                pageSize:    String(LOAD_PAGE_SIZE),
              },
            })
            if (loadId !== this.partsLoadId) return

            const rows = Array.isArray(res) ? res : res.items || []
            if (rows.length > 0) {
              this.$store.commit('appendParts', rows)
              this.applyLocalSearch()
            }

            if (Array.isArray(res) || !res.hasMore) break
          }

          if (loadId === this.partsLoadId) {
            this.$store.commit('setPartsLoaded', true)
          }
        } finally {
          if (loadId === this.partsLoadId) {
            this.tableProperties.loading = false
          }
        }
      },
      applyLocalSearch() {
        const s = (this.searchQuery || '').trim()
        const allParts = this.$store.state.parts || []

        if (s.length === 0) {
          this.tableProperties.items = allParts
          return
        }

        if (s.length === 1) {
          this.tableProperties.items = []
          return
        }

        const needle = s.toLowerCase()
        this.tableProperties.items = allParts.filter((part) =>
          [part.PARTNAME, part.PARTDES].some((value) =>
            (value || '').toString().toLowerCase().includes(needle)
          )
        )
      },
    },
    watch: {
      searchQuery() {
        this.tableProperties.resetPageKey += 1
        this.applyLocalSearch()
      },
    },
  }
</script>
